document.addEventListener('DOMContentLoaded', function() {
  var menuSelect = document.getElementById('menu-select');
  if (menuSelect) {
      menuSelect.addEventListener('change', function() {
          if (this.value) {
              window.location.href = this.value;
          }
      });
  }
});